/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// CommonStyles.js

import { makeStyles } from "@material-ui/core";

export const CommonStyles = makeStyles(() => ({
    // EditRecipient
    dialogTitle: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: '700',
    },
    backButtonContainer: {
        width: 'max-content',
        marginRight: 'auto',
    },
    contentText: {
        textAlign: 'center',
    },
    // AddOccasions
    addOccasionStyle: {
        width: '100%',
    },
    errorContainer: {
        color: 'red'
    },
    marginBottom10: {
        marginBottom: '10px'
    },
    marginTopB: {
        marginTop: '16px',
        marginBottom: '16px'
    },
    occasionDivider: {
        margin: '10px 0px',
        width: '100%'
    },
    occassionGrid: {
        marginRight: '5px', 
        alignItems: 'center', 
        flexFlow: 'nowrap'
    },
    occassionSwitch: {
        alignItems: 'center', 
        justifyContent: 'end'
    }
}));

export const DesktopAddNewRecipientStyles = {
    container: {
        width: '74.8%',
        margin: '24px 3% 0px 5%',
    },
    desktopAddNewRecipient: {
        padding: '20px 24px 0px 20px',
        width: '100%',
    },
    backButtonContainer: {
        width: 'max-content',
        cursor: 'pointer',
    },
    backButtonIcon: {
        marginLeft: '8px',
        width: 'fit-content',
        fontWeight: 700,
    },
    formStyle: {
        width: '100%',
    },
    pageTitleWrapper: {
        margin: '3vh 0',
    },
    dividerStyle: {
        margin: '24px 0px',
        width: '100%',
    },
    marginTop24: {
        marginTop: '24px',
    },
    errorMessageContainer: {
        color: 'red',
        marginTop: '10px',
    },
    marginTop32: {
        marginTop: '32px',
    },
    gridItem: {
        borderRadius: '0px',
        marginTop: '8px'
    },
    buttonStyle: {
        margin: '24px 0px 80px 0px',
        textAlign: 'center'
    },
    noRecipient: {
        textAlign: 'center',
        marginTop: '50px',
        fontSize: '16px'
    }
}

export const DesktopEditRecipientStyle = {
    desktopAddNewRecipient: {
        width: '74.8%',
        margin: '24px 3% 0px 5%',
    },
    recipientBookListResError: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
}

export const AddNewRecipientStyles = {
    pageTitleWrapper: {
        margin: '1.5rem'
    },
    dialogActions: {
        justifyContent: 'space-evenly',
        padding: '20px 20px 30px 20px',
    }
}

export const useDialogStyles = makeStyles(() => ({
    dialogContent: {
        padding: '20px',
    },
    closeButton: {
        position: 'absolute',
        right: '-9px',
        top: '-9px',
        cursor: 'pointer',
    },
    dialogText: {
        color: '#000000',
        textAlign: 'center',
    },
    errorContainer: {
        color: 'red',
        marginBottom: '0px',
        textAlign: 'center',
        margin: '12px',
    },
    commonGap: {
        gap: '16px',
    },
}));

export const useQasAddressConfirmationDialogStyles = makeStyles(() => ({
    confirmationDialogWrapper: {
        padding: '30px',
    }
}));

export const commonUseStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    orderContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    gridItem: {
        padding: '20px 11px 0 43px',
    },
    errorContainer: {
        color: 'red',
        fontSize: '12px',
        marginTop: '-18px',
        marginBottom: '10px'
    },
    mediumFont: {
        fontSize: '16px'
    },
    smallFont: {
        fontSize: '14px'
    },
    gridAlign: {
        alignItems: 'center'
    },
    gridRecipient: {
        wordBreak: 'break-word',
        maxWidth: '250px'
    },
    recipientBtn: {
        borderRadius: '0px',
        cursor: 'pointer'
    },
    positionRel: {
        position: 'relative'
    },
    marginBO: {
        marginBottom: '0'
    },
    error: {
        color: 'red'
    },
    legalCopyFont: {
        fontSize: '14px',
        lineHeight: '20px'
    },
    centerHeader: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    },
    ctaBtn: {
        textDecorationThickness: '2px',
        textUnderlineOffset: '2px',
        textTransform: 'none',
        justifyContent: 'left',
        maxWidth: 'fit-content',
        color: '#FFFFFF',
    },
    apiError: {
        fontSize: '12px',
        color: 'red',
        display: 'block'
    },
    dialogTitle: {
        padding: '30px 53px 28px 53px', 
        width: '400px'
    },
    linkStyle: {
        color: '#1F6BC6'
    },
    footMargin: {
        marginLeft: '16px', 
        marginTop: '32px'
    }
}));